/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface CreateSpecialHourResponse
 */
export interface CreateSpecialHourResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof CreateSpecialHourResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
}

/**
 * Check if a given object implements the CreateSpecialHourResponse interface.
 */
export function instanceOfCreateSpecialHourResponse(value: object): value is CreateSpecialHourResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateSpecialHourResponseFromJSON(json: any): CreateSpecialHourResponse {
    return CreateSpecialHourResponseFromJSONTyped(json, false);
}

export function CreateSpecialHourResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSpecialHourResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
    };
}

export function CreateSpecialHourResponseToJSON(json: any): CreateSpecialHourResponse {
    return CreateSpecialHourResponseToJSONTyped(json, false);
}

export function CreateSpecialHourResponseToJSONTyped(value?: CreateSpecialHourResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
    };
}

